import { Navigate, useParams } from 'react-router-dom';

// Component to handle protected routes
const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('user');
    const { id } = useParams(); // Get the id from the URL parameters

    if (token) {
        return children; // If token exists, render the children components
    } else {
        // If no token, store the id in local storage
        if (id) {
            localStorage.setItem('redirectId', id);
        }
        return <Navigate to="/login" />;
    }
};

export default ProtectedRoute;
